import { useEffect, useState } from 'react';
import { hot } from 'react-hot-loader';
import Modal, { useModalState/*, useModal*/ } from 'react-simple-modal-provider';



function pause(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

const VideoModal = ({ children }) => {
  const [isOpen, setOpen] = useModalState();
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }, [isOpen]);
  /*const onClose = () => {
    setOpen(false);
  }*/
  /*const [data, setData] = useState(null);
  const asyncOpen = async () => {
    try {
      await new Promise((r) => setTimeout(r, 1000));
      setData({});
    } catch (error) { console.error(error); }
  };*/
  // const { open: openTemplateModal } = useModal('TemplateModal');

  const [video, setVideo] = useState(null);
  const [rendered, setRendered] = useState(false);

  useEffect(async () => {
    if (isOpen) {
      await pause(500);
      try {
        const video = new window.VdoPlayer({
          otp: "20160313versASE323ZQ6j4F4jA3eJKOqzEAetBJRfJFBriLpChUVE5POsouqn9X",
          playbackInfo: "eyJ2aWRlb0lkIjoiOTg1OTA0MDg4MjM0NDhhZTgwZTQ4YTMzYTMwMjBiOGIifQ==",
          theme: "9ae8bbe8dd964ddc9bdb932cca1cb59a",
          // the container can be any DOM element on website
          container: document.querySelector("#vdoqzEAetBJRf"),
        });

        video.addEventListener(`load`, () => {
          video.play(); // this will auto-start the video
          console.log('loaded');
        });
      } catch (error) { console.error(error); }
    }
  }, [isOpen, window.VdoPlayer]);


  return (
    <Modal
      id={'VideoModal'}
      consumer={children}
      isOpen={isOpen}
      setOpen={setOpen}
      //asyncOpen={asyncOpen}
      draggable={false}
      duration={300}
      //animation={modalAnimation.scaleUp}
      width={300}
      height={300}
      radius={10}
      backgroundColor={'#fff'}
    >
      <div
        id="vdoqzEAetBJRf"
        style={{ height: 'auto', width: '720px', maxWidth: '100%', }}
      ></div>
    </Modal>
  );
};

export default hot(module)(VideoModal);
